








































































































































import { Component, Vue } from 'vue-property-decorator';
import VueI18n from 'vue-i18n';
import { namespace } from 'vuex-class';

import {
  goToPrequalification,
  goToAuction,
  goToFinancialSecurity,
  goToSecondaryMarket,
  goToPDM,
  goToAvMonitoring,
  goToSettlement,
} from "@/lib/redirection";
import i18n from "@/GlobalResource";
import getBrowserLocale, { getChoosenLanguage, setChoosenLanguage } from '@/lib/locale';
import { registerForm } from "@/fixtures/register";
import { FormRegister } from '@/types';
import IAppSettings from 'arc4u.framework.js/token/IAppSettings';
import AppSettings from 'arc4u.framework.js/token/AppSettings';
import { CandidateRegistrationClient } from '@/proxy/Prequalification.CandidateMgt.FacadeClient';
import TokenKeys from 'arc4u.framework.js/token/TokenKeys';
import { AgreementPublicClient } from '@/proxy/Prequalification.Legal.FacadeClient';
import { DownloadDocumentFrom64 } from '@/lib/documents';
import { mutationTypes as errorsMutationTypes } from '@/store/module/errors/mutations';

const errors = namespace('errors');

@Component({})
export default class Home extends Vue {
  @errors.Mutation(errorsMutationTypes.setError)
  setError!: (value?: string) => void;
  
  forgotPasswordUrl: string = "";
  i18n: VueI18n = i18n;

  goToPrequalification: any = goToPrequalification;
  goToAuction: any = goToAuction;
  goToFinancialSecurity: any = goToFinancialSecurity;
  goToSecondaryMarket: any = goToSecondaryMarket;
  goToPDM: any = goToPDM;
  goToAvMonitoring:  Function = goToAvMonitoring;
  goToSettlement:  Function = goToSettlement;

  disclaimer: string | null = null;
  smicon: string | null = null;
  isDownloading: boolean = false;

  registerForm: FormRegister = registerForm;

  // hook
  async created(): Promise<void> {
    i18n.locale = (
      getChoosenLanguage() ?? getBrowserLocale({ countryCodeOnly: true, fallbackLocale: i18n.fallbackLocale.toString() })
    );

    const settings: IAppSettings = AppSettings.Get("OAuth");
    const smicon = settings.Values.filter(v => v.Key === "SMIcon");
    if (smicon.length > 0) {
      this.smicon = smicon[0].Value;
    }

    let urlSettings = settings.Values.filter(v => v.Key === "ForgotPasswordUrl");
    if (urlSettings.length > 0) {
      this.forgotPasswordUrl = urlSettings[0].Value;
    }
    
    const regProxy = new CandidateRegistrationClient(
      settings.Values.filter(v => v.Key === TokenKeys.RootServiceUrlKey)[0].Value
    );

    this.disclaimer = await regProxy.getDisclaimer();
  }
  
  goToRegistration() {
    this.$router.push('/registration');
  }

  goToForgotPassword() {
    if (!this.forgotPasswordUrl) {
      return;
    }

    window.open(this.forgotPasswordUrl, '_blank');
  }

  onSelectLanguage(lng: string): void {
    setChoosenLanguage(lng);
  }

  async onDownloadPrivacyPolicy() {
    this.isDownloading = true;
    try {
      let settings: IAppSettings = AppSettings.Get("OAuth");
      var proxy = new AgreementPublicClient(
        settings.Values.filter(v => v.Key === TokenKeys.RootServiceUrlKey)[0].Value
      );
      var result = await proxy.getPrivacyPolicy();
      DownloadDocumentFrom64(result!.content, "Privacy Policy", "pdf");
    } catch (e) {
      this.setError();
    }

    this.isDownloading = false;
  }
};
